import { render, staticRenderFns } from "./WillisFooter.vue?vue&type=template&id=1deec271&scoped=true&"
import script from "./WillisFooter.vue?vue&type=script&lang=js&"
export * from "./WillisFooter.vue?vue&type=script&lang=js&"
import style0 from "./WillisFooter.vue?vue&type=style&index=0&id=1deec271&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deec271",
  null
  
)

export default component.exports